
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetomumbaicabs() {



    const cardData =
    {
        keyword: '  Pune to Mumbai Cabs',
        heading: 'Mauli Cabs:  Pune to Mumbai Cabs',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Pune to Mumbai cab services, ensuring a smooth and stress-free journey between the two cities. Whether you are traveling for business, leisure, or a special event, we provide a variety of well-maintained vehicles including sedans, SUVs, and premium cabs to meet your travel needs. With experienced drivers, transparent pricing, no hidden charges, and a strong commitment to punctuality and customer satisfaction, Mauli Cabs guarantees a comfortable and hassle-free ride from Pune to Mumbai.',

        top: 'Top Places to Visit in Mumbai with Mauli Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "The Gateway of India is an iconic monument located on the waterfront in South Mumbai. Built during the 20th century, it served as a ceremonial entrance to India for Viceroys and new Governors of Bombay."
    },
    {
        "title": "Marine Drive",
        "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6-kilometer-long boulevard along the South Mumbai coast. It's a perfect place for a scenic walk and offers stunning sunset views."
    },
    {
        "title": "Elephanta Caves",
        "description": "Elephanta Caves are a network of sculpted caves located on Elephanta Island, about 11 km from the city. They feature impressive rock-cut sculptures and are a UNESCO World Heritage Site."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "This UNESCO World Heritage Site is an outstanding example of Victorian Gothic Revival architecture in India, and it serves as one of Mumbai's busiest railway stations."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "The Siddhivinayak Temple is a revered Hindu temple dedicated to Lord Ganesha. Located in Prabhadevi, it attracts thousands of devotees daily seeking blessings."
    },
    {
        "title": "Colaba Causeway",
        "description": "Colaba Causeway is a vibrant shopping street lined with street stalls and boutiques selling clothes, jewelry, handicrafts, and antiques, making it a must-visit for shopaholics."
    },
    {
        "title": "Juhu Beach",
        "description": "Juhu Beach is one of Mumbai’s most famous beaches, popular for its street food, especially bhelpuri and pav bhaji, and for evening strolls along the Arabian Sea."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "Located on an islet off the coast of Worli, the Haji Ali Dargah is a mosque and tomb built in memory of a wealthy Muslim merchant who gave up his worldly possessions before making a pilgrimage to Mecca."
    },
    {
        "title": "Chowpatty Beach",
        "description": "Chowpatty Beach is famous for its lively atmosphere, street food, and being a central spot for Ganesh Chaturthi celebrations where devotees immerse Ganesh idols in the sea."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Located in the northern part of Mumbai, Sanjay Gandhi National Park is a green oasis offering trekking, a mini train ride, and a chance to visit the historic Kanheri Caves."
    }
],

"services": [
    {
      "name": "Pune Mumbai Cab",
      "description": "Book a reliable cab from Pune to Mumbai for business or leisure travel. Multiple car options available with experienced drivers and affordable pricing."
    },
    {
      "name": "Mumbai to Pune Taxi",
      "description": "Hire a taxi from Mumbai to Pune with guaranteed on-time pickup, safe drivers, and clean vehicles for a hassle-free return trip."
    },
    {
      "name": "Pune to Mumbai Cheapest Cab",
      "description": "Find the most affordable cabs for Pune to Mumbai travel. Budget vehicles, fixed fares, and no hidden charges ensure a cost-effective ride."
    },
    {
      "name": "Pune to Mumbai Cab Service",
      "description": "Professional cab services for Pune to Mumbai with easy booking, comfortable vehicles, and round-the-clock availability."
    },
    {
      "name": "Pune to Mumbai Cab Fare",
      "description": "Check the fare structure for Pune to Mumbai cabs with transparent pricing based on car type, route, and timing."
    },
    {
      "name": "Pune Mumbai Taxi Service",
      "description": "Trusted taxi service between Pune and Mumbai with one-way or round-trip options. Great for airport transfers and city-to-city travel."
    },
    {
      "name": "Pune to Mumbai Cab Booking",
      "description": "Book cabs online or via phone for Pune to Mumbai route. Instant confirmation, 24/7 availability, and various vehicle types offered."
    },
    {
      "name": "Pune Mumbai Cab Rental",
      "description": "Cab rental service between Pune and Mumbai for individuals, families, and corporates. Options include hatchbacks, sedans, and SUVs."
    },
    {
      "name": "Pune Mumbai Pune Car Rental",
      "description": "Round-trip car rental from Pune to Mumbai and back. Ideal for day trips, meetings, and tours with flexible return times."
    },
    {
      "name": "Pune Mumbai Taxi Price",
      "description": "Compare taxi prices for Pune to Mumbai routes. Choose from economy to premium vehicles with upfront pricing and no surprises."
    },
    {
      "name": "Pune Mumbai Car Rental",
      "description": "Rent a car for travel between Pune and Mumbai. Comfortable rides, door-to-door service, and experienced drivers included."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Book a Maruti Ertiga cab for your Pune to Mumbai trip. Perfect for small groups or families needing space and comfort at a good price."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Travel in style from Pune to Mumbai with a Toyota Innova. Spacious, AC-equipped, and ideal for longer journeys or group travel."
    },
    {
      "name": "Pune to Mumbai Innova Crysta",
      "description": "Book a premium Innova Crysta for your Pune to Mumbai ride. Ideal for luxury travel or corporate trips with added comfort and class."
    },
    {
      "name": "Pune Mumbai Innova Rental",
      "description": "Innova rentals available for Pune to Mumbai trips. Choose between Crysta and Standard models with driver and fixed rates."
    },
    {
      "name": "Pune to Mumbai International Airport Cab",
      "description": "Hire a cab from Pune to Mumbai International Airport. Timely service, luggage assistance, and clean vehicles guaranteed."
    },
    {
      "name": "Pune to Mumbai Mauli  Cabs",
      "description": "Choose Pune to Mumbai Mauli  Cabs for reliable service, affordable fares, and courteous drivers. Trusted by frequent travelers."
    }
  ],
  "tableData": [
    ["Pune Mumbai Cab", "Mumbai to Pune Taxi"],
    ["Pune to Mumbai Cheapest Cab", "Pune to Mumbai Cab Service"],
    ["Pune to Mumbai Cab Fare", "Pune Mumbai Taxi Service"],
    ["Pune to Mumbai Cab Booking", "Pune Mumbai Cab Rental"],
    ["Pune Mumbai Pune Car Rental", "Pune Mumbai Taxi Price"],
    ["Pune Mumbai Car Rental", "Pune to Mumbai Ertiga Cab"],
    ["Pune to Mumbai Innova Cab", "Pune to Mumbai Innova Crysta"],
    ["Pune Mumbai Innova Rental", "Pune to Mumbai International Airport Cab"],
    ["Pune to Mumbai Mauli  Cabs", ""]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Convenient and Reliable Taxi Service",
        "WhyChoosedescription": "Mauli Cabs offers reliable and on-time taxi services in Viman Nagar, Pune. Whether you need a quick ride to the airport, a business meeting, or a leisurely outing, we ensure a hassle-free travel experience."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles Available",
        "WhyChoosedescription": "Choose from a variety of well-maintained vehicles including hatchbacks, sedans, and SUVs for your trip around Viman Nagar. We provide comfortable and spacious options to suit your travel needs."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are professional, courteous, and experienced with local routes. They ensure a safe, comfortable, and timely ride, whether you're traveling to the airport or exploring the local attractions."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable rates for taxi rides within Viman Nagar and beyond. Enjoy transparent pricing with no hidden charges, ensuring you get value for money on every trip."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Need a taxi at any time of day or night? We are available 24/7 in Viman Nagar, ensuring you always have a taxi ready whenever you need it, whether for early morning or late-night trips."
    },
    {
        "WhyChooseheading": "Easy Booking Process",
        "WhyChoosedescription": "Booking a taxi in Viman Nagar is quick and easy with our user-friendly website and app. You can book a ride in just a few clicks and track your taxi in real-time for added convenience."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Taxis",
        "WhyChoosedescription": "Our taxis are regularly serviced and cleaned to ensure a smooth and comfortable ride. Enjoy a safe and pleasant experience every time you book a taxi in Viman Nagar."
    },
    {
        "WhyChooseheading": "Perfect for Airport Transfers",
        "WhyChoosedescription": "Traveling to or from Pune Airport? Mauli Cabs offers dedicated airport taxi services in Viman Nagar. We ensure timely pick-up and drop-off to ensure you never miss your flight or have to wait for long."
    }
]






















    }


    const faqData = [
        {
            question: 'How do I book a cab from Pune to Mumbai with Mauli Cabs?',
            answer: 'You can book a Pune to Mumbai cab easily through our website or mobile app. Just enter "Pune" as the pickup location and "Mumbai" as the drop-off location, choose your preferred vehicle type, and confirm your booking. Our support team is also available to assist you with bookings.',
        },
        {
            question: 'What types of cabs are available for Pune to Mumbai travel?',
            answer: 'Mauli Cabs offers a range of vehicles including Hatchbacks, Sedans, SUVs, Ertiga, Innova Crysta, and premium cars. Choose a vehicle based on your comfort, number of passengers, and luggage needs.',
        },
        {
            question: 'Is the fare for the Pune to Mumbai route fixed?',
            answer: 'Yes, our pricing is fixed and transparent. The fare includes tolls, taxes, driver allowance, and fuel. There are no hidden charges, and the complete fare is displayed at the time of booking.',
        },
        {
            question: 'How long does it take to travel from Pune to Mumbai by cab?',
            answer: 'The travel time from Pune to Mumbai generally ranges between 3.5 to 5 hours, depending on traffic and road conditions. We recommend early departures for a smoother experience.',
        },
        {
            question: 'Can I book a one-way or round trip cab from Pune to Mumbai?',
            answer: 'Yes, you can choose either a one-way or round trip option based on your needs. Round trip bookings offer added convenience and value if you’re planning a return journey the same or next day.',
        },
        {
            question: 'Is Mauli Cabs available for early morning or late-night pickups?',
            answer: 'Absolutely. We operate 24/7, so you can book a cab from Pune to Mumbai at any time of the day or night. Our drivers ensure safe and punctual service.',
        },
        {
            question: 'Can I carry extra luggage on the Pune to Mumbai route?',
            answer: 'Yes, if you’re carrying more than standard luggage, we recommend booking a larger vehicle like an SUV or Innova Crysta to ensure space and comfort for all passengers.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Sunil Deshpande",
            position: "Frequent Business Traveler",
            text: "I travel often between Pune and Mumbai and always rely on Mauli Cabs. Their service is prompt, professional, and comfortable—perfect for business trips!",
            image: "/img/testimonial/testimonial-thumb-1-19.png",
        },
        {
            name: "Miss. Priya Sawant",
            position: "Student",
            text: "Booked a cab from Pune to Mumbai for my weekend trip. The booking was smooth, the car was clean, and the driver was friendly. Highly recommend Mauli Cabs!",
            image: "/img/testimonial/testimonial-thumb-1-20.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Mumbai Cab Service by Mauli Cabs",
        "description": "Mauli Cabs provides affordable and reliable Pune to Mumbai cab services including one-way and round trip options. Choose from Ertiga, Innova, and Innova Crysta for a comfortable ride to Mumbai or the international airport with 24x7 booking support.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "8800"
        }
      };
      
      

    return (
        <div>
            <GTag/>


<Helmet>
        <title>Pune to Mumbai Cabs | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Mumbai cab with Mauli Cabs. Affordable, 24x7 cab service with options like Ertiga, Innova, and Crysta for airport transfers and city travel. Reliable Pune to Mumbai taxi booking."
        />
        <meta
          name="keywords"
          content="Pune mumbai cab, mumbai to pune taxi, pune to mumbai cheapest cab, pune to mumbai cab service, pune to mumbai cab fare, pune mumbai taxi service, pune to mumbai cab booking, pune mumbai cab rental, pune mumbai pune car rental, pune mumbai taxi price, Pune Mumbai car rental, pune to mumbai ertiga cab, Pune to Mumbai Innova Cab, pune to mumbai cab booking, pune to mumbai innova crysta, pune mumbai innova rental, pune to mumbai international airport cab, Pune to mumbai cab fare, Pune to Mumbai Mauli Cabs"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/65.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaicabs;